import * as api from 'utils/axios';
import * as endpoints from 'services/summary/endpoints';
import { SCAN_API } from 'config';

export const summary = (summaryType: string, characteristic?: string) =>
  api.sendPost(SCAN_API + endpoints.SUMMARY, {
    summaryType,
    characteristic,
  });
